module.exports = __webpack_public_path__ + "static/media/quadrant-devs-dedicated-pro-collab.08818278.svg";